// extracted by mini-css-extract-plugin
module.exports = {"status-selector":"StatusSelector_status-selector__1QymP","cancel":"StatusSelector_cancel__2wSoF"};